import LoadAdobeScript from "@tm/insurance/analytics/loadAdobeScript";
import {
  MyPartnerHeaderProps,
  MyPartnerInsuranceHeader,
} from "../static/components/MyPartnerInsuranceHeader";

interface MyPartnerHeaderPropsWithWrapper extends MyPartnerHeaderProps {
  Wrapper?: (props: { children: JSX.Element[] }) => JSX.Element;
}

export function withMyPartnerInsuranceHeader(
  component: JSX.Element,
  headerOptions: MyPartnerHeaderPropsWithWrapper = {},
  mobileTitle = "",
  b2bLayoutData: any ={},
  myOrders = false,
  goToMyOrders = () => void 0,
  displayWhiteHeader = false,
  isMyBiz = false,
  exitWebViewOnBack = false
) {
  const { Wrapper, ...headerProps } = headerOptions;
  const authComponent = (
    <MyPartnerInsuranceHeader
      headerProps={headerProps}
      mobileTitle={mobileTitle}
      myOrders={myOrders}
      b2bLayoutData = {b2bLayoutData}
      goToMyOrders={goToMyOrders}
      displayWhiteHeader={displayWhiteHeader}
      isMyBiz={isMyBiz}
      exitWebViewOnBack={exitWebViewOnBack}
    />
  );

  if (headerProps?.forceLogin && typeof window !== "undefined") {
    window.location.href = "https://mypartner.makemytrip.com/";
  }

  if (Wrapper) {
    return (
      <Wrapper>
        <LoadAdobeScript />
        {authComponent}
        {component}
      </Wrapper>
    );
  }
  return (
    <>
      <LoadAdobeScript />
      {authComponent}
      {component}
    </>
  );
}
